import React, { useState } from "react";
import GetAppIcon from '@material-ui/icons/GetApp';
import { Button, CircularProgress } from '@material-ui/core';
import { useStateAuthValue } from '../../../context/Auth/AuthState';
import { useToast } from '../../../context/Toast/ToastProvider';
import { GetPrescriptionPdf } from '../../../services/prescriptionService';
import { showToast, ToastType } from '../../../utils/ToastUtil';
import PdfViewerDialog from './pdfViewerDialog';

// Los WebView ignoran las descargas blob: se muestra el PDF dentro de la app
const isWebView = /; wv\)|(iPhone|iPod|iPad)(?!.*Safari)/i.test(navigator.userAgent);

const PrescriptionPdfButton = ({ prescriptionId, fileName, getPdf = GetPrescriptionPdf }) => {
  const [{ userToken }] = useStateAuthValue();
  const toastDispatch = useToast();
  const [downloading, setDownloading] = useState(false);
  const [viewerBlob, setViewerBlob] = useState(null);
  const pdfFileName = `${fileName || 'receta'}.pdf`;

  const downloadPdf = async () => {
    setDownloading(true);
    try {
      const blob = await getPdf(prescriptionId, userToken);
      if (isWebView) {
        setViewerBlob(blob);
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = pdfFileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (e) {
      showToast(toastDispatch, 'No se pudo descargar el PDF', ToastType.ERROR, ToastType.ERROR);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Button
        style={{ marginLeft: 16 }}
        size="small"
        color="primary"
        disabled={downloading}
        startIcon={downloading ? <CircularProgress size={16} /> : <GetAppIcon />}
        onClick={downloadPdf}
      >
        {downloading ? 'Descargando...' : isWebView ? 'Ver PDF' : 'Descargar'}
      </Button>
      {viewerBlob && (
        <PdfViewerDialog blob={viewerBlob} onClose={() => setViewerBlob(null)} />
      )}
    </>
  );
};

export default PrescriptionPdfButton;
